import(/* webpackMode: "eager" */ "/var/www/msa-rider-frontend/src/app/error.tsx");
